// extracted by mini-css-extract-plugin
export default {"scope":"sr1lz","ring":"x0fLI"};